export const US = "US";
export const UK = "UK";

export const DEFAULT_VERSION = UK;

export const getVersion = () => {
    const { hostname } = window.location;

    if (hostname.endsWith(".co.uk")) return UK;
    if (hostname.endsWith(".com") || hostname.endsWith(".org")) return US;

    return DEFAULT_VERSION;
};

export const isVersionUK = getVersion() === UK;
export const isVersionUS = getVersion() === US;
